export enum DialogHeight {
	MaxContent = "h-max-content",
	Full = "h-100",
}
